/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".language__selector--login[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:15px}.language__selector--login[_ngcontent-%COMP%]   .kt-header__topbar-wrapper[_ngcontent-%COMP%]:hover{cursor:pointer}.language__selector--login[_ngcontent-%COMP%]   .selected__language[_ngcontent-%COMP%]{text-align:left;padding:0 5px;font-family:Poppins;font-size:1.2rem;letter-spacing:0;color:#414042;opacity:1}"];
export { styles as styles };
